<template>
  <div style="padding-left: 10px">
    <el-row class="search-box">
      <el-input v-model.trim="sn" placeholder="请扫SN码" @keyup.enter="search" clearable class="input"></el-input>
      <el-input v-model.trim="inLineCnt" placeholder="请输入来货序号" @keyup.enter="search" clearable class="input"></el-input>
      <el-button :loading="loading" @click="search">查询</el-button>
      <KfMessage ref="searchMessage"/>
    </el-row>
    <el-card shadow="never" class="info-card">
      <el-row>
        <el-col :span="2" class="item-text">当前工站：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.current_station_name }}</el-col>
        <el-col :span="2" class="item-text">当前工站状态：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.current_station_status_name }}</el-col>
        <el-col :span="2" class="item-text">当前工站责任人：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.current_station_user_name }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="2" class="item-text">下一站：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.next_station_name }}</el-col>
        <el-col :span="2" class="item-text">SN：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.sn }}</el-col>
        <el-col :span="2" class="item-text">旧SN：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.swap_sn }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="2" class="item-text">料号：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.material_code }}</el-col>
        <el-col :span="2" class="item-text">服务单号：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.receive?.order_no }}</el-col>
        <el-col :span="2" class="item-text">服务模式：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.receive?.service_mode_name }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="2" class="item-text">品牌：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.brand_name }}</el-col>
        <el-col :span="2" class="item-text">品类：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.catalog_name }}</el-col>
        <el-col :span="2" class="item-text">送修类别：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.send_repair_type_name }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="2" class="item-text">发货箱数：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.receive?.send_box_cnt }}</el-col>
        <el-col :span="2" class="item-text">实际接收箱数：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.receive?.receive_box_cnt }}</el-col>
        <el-col :span="2" class="item-text">外箱损坏数量：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.receive?.box_ng_cnt }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="2" class="item-text">发货物品数量：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.receive?.send_item_cnt }}</el-col>
        <el-col :span="2" class="item-text">接收物品数量：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.receive?.receive_item_cnt }}</el-col>
        <el-col :span="2" class="item-text">物品损坏数量：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.receive?.item_ng_cnt }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="2" class="item-text">新型号：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.model }}</el-col>
        <el-col :span="2" class="item-text">旧型号：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.swap_model }}</el-col>
        <el-col :span="2" class="item-text">接收状态：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.receive_status_name }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="2" class="item-text">来货序号：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.in_line_cnt }}</el-col>
        <el-col :span="2" class="item-text">CID/VID：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.cid }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="2" class="item-text">故障现象：</el-col>
        <el-col :span="4" class="item-value">{{ snInfo.trouble_desc }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="2" class="item-text">上次维修人员：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.prev_repair_user_name }}</el-col>
        <el-col :span="2" class="item-text">上次测试人员：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.prev_test_user_name }}</el-col>
        <el-col :span="2" class="item-text">发板指定维修人：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.assign_repair_user_name }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="2" class="item-text">上次维修时间：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.prev_repair_time }}</el-col>
        <el-col :span="2" class="item-text">进流水线时间：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.in_line_time }}</el-col>
        <el-col :span="2" class="item-text">出流水线时间：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.out_line_time }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="2" class="item-text">是否二返：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.is_two_return }}</el-col>
        <el-col :span="2" class="item-text">是否全部结束：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.total_end }}</el-col>
      </el-row>
    </el-card>

    <KfTableTitle title="物品工站作业记录" style="margin-top: 20px"></KfTableTitle>
    <el-table :data="snInfo.logList">
      <el-table-column label="工站" prop="station_name"></el-table-column>
      <el-table-column label="进站时间" prop="in_time"></el-table-column>
      <el-table-column label="出站时间" prop="out_time"></el-table-column>
      <el-table-column label="作业结果" prop="result_name"></el-table-column>
      <el-table-column label="作业人" prop="create_user_name"></el-table-column>
            <el-table-column label="详情">
              <template #default="scope">
                <FrameButton :button="showDetail(scope.row)" />
              </template>
            </el-table-column>
    </el-table>


  </div>
</template>

<script>
export default {
  name: "SnSearch",
  components: {},
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      sn: '',
      inLineCnt:"",
      loading: false,
      snInfo: {},
    }
  },
  computed: {},
  provide() {
    return {
      $fn: {
        reset: () => {
          this.sn = ''
          this.reset();
        }
      }
    }
  },
  methods: {
    async search() {
      this.reset()
      //this.$refs.frameForm.formInfo = {} //清空作业表单内容

      if (!this.sn) {
        return this.$refs.searchMessage.showError('SN码不能为空')
      }

      this.loading = true
      this.$http('repairItemService.getSnInfo', {
        sn: this.sn
        ,in_line_cnt:this.inLineCnt
      }, false).then(data => {
        this.loading = false
        this.snInfo = data || {}
      }, errMsg => {
        this.loading = false
        return this.$refs.searchMessage.showError(errMsg)
      })
    },
    reset() {
      this.snInfo = {}
      this.$refs.searchMessage.clear()

    },

    showDetail(row){

        let button = {
          "component": "button",
          "type": "text",
          "text":true,
          "style": "color:#00aaff",
          "click": "jsOpenWindow",
          "label":"详情"
        }

        let windowObj = {}
        windowObj.icon = "system/tools";
        windowObj.component = "repair/SnSearchDetail";
        windowObj.type = row.id;
        windowObj.title = row.station_name;
        windowObj.width = 800
        windowObj.height = 600
        windowObj.max = false

        button.window = windowObj
        return button

    },

  }
}
</script>

<style scoped>
.el-row {
  line-height: 32px;
}

.info-card {
  margin-top: 10px;
}

.remind-card {
  margin-top: 10px;
  width: 1000px;
}

.info-card .el-row {
  display: flex;
}

.input {
  height: 32px;
  width: 250px;
  margin-right: 10px;
}

.search-box {
  padding-top: 10px;
  line-height: 40px;
  min-height: 50px;
}

.item-text {
  text-align: left;
}

.item-value {
  color: goldenrod;
}

.login-user {
  position: absolute;
  right: 10px;
}

.item-text {
  text-align: right;
}

.item-value.red-tip {
  color: red;
}

</style>